import { useState, useEffect } from 'react';
import { Typography } from "@bezlimit/bezlimit-ui";
import { useLocation } from 'react-router-dom';
import './style.scss'

interface LoadingProps {
    visible?: boolean;
    hideText?: boolean;
}

export default function Loading({ visible = true, hideText = false }: LoadingProps) {
    const location = useLocation();
    
    const loadingTexts = [
        "Загружаем нужное…",
        "Почти готово…",
        "Ещё чуть-чуть ✨",
        "Финальный штрих…",
        "Творим магию…",
        "Добавляем искры ✨",
        "Подстраиваем под вас…",
        "Собираем байтики в кучку…",
        "Подкручиваем настройки…",
        "Делаем красиво…",
        "Уже можно радоваться 😎",
        "Всё получилось ✨",
    ];

    const [currentTextIndex, setCurrentTextIndex] = useState(0);

    useEffect(() => {
        if (!visible || hideText) {
            setCurrentTextIndex(0);
            return;
        }

        setCurrentTextIndex(0);
        let current = 0;
        
        const interval = setInterval(() => {
            current += 1;
            if (current >= loadingTexts.length - 1) {
                setCurrentTextIndex(loadingTexts.length - 1);
                clearInterval(interval);
            } else {
                setCurrentTextIndex(current);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [visible, hideText, location.pathname]);

    return (
        <Typography as="div" className="preloader-wrapper">
            {!hideText && (
                <Typography as="div" className="preloader__text-container">
                    <Typography
                        as="span"
                        className="preloader__text"
                    >
                        {loadingTexts[currentTextIndex]}
                    </Typography>
                </Typography>
            )}
            <Typography as="div" className="preloader" />
        </Typography>
    );
}